export default "__VITE_ASSET__DmuZfa1Q__"